import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=2f3f9833&scoped=true"
import script from "./coming-soon.vue?vue&type=script&lang=js"
export * from "./coming-soon.vue?vue&type=script&lang=js"
import style0 from "./coming-soon.vue?vue&type=style&index=0&id=2f3f9833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f9833",
  null
  
)

export default component.exports